import { IStoreState } from '../../../types'
import { IServicePricingModel, IServicePricingState } from '../../../types/service-pricing'
import {
  IServicePricingAction,
  IServicePricingRequestFail,
  IServicePricingRequestSuccess,
  IServicePricingUpdateFail,
  IServicePricingUpdateSuccess
} from '../../actions/services/servicePricing'
import {
  SERVICE_PRICING_REQUEST,
  SERVICE_PRICING_REQUEST_FAIL,
  SERVICE_PRICING_REQUEST_SUCCESS,
  SERVICE_PRICING_UPDATE,
  SERVICE_PRICING_UPDATE_FAIL,
  SERVICE_PRICING_UPDATE_SUCCESS
} from '../../constants'

function setServicePricingRequesting(
  state: IServicePricingState = initialState,
  action: IServicePricingAction
): IServicePricingState {
  return Object.assign({}, state, {
    metadata: {
      ...state.metadata,
      fetching: true
    }
  })
}

function setServicePricingRequestSuccess(
  state: IServicePricingState = initialState,
  action: IServicePricingAction
): IServicePricingState {
  const data = (action as IServicePricingRequestSuccess).data
  return Object.assign({}, state, {
    metadata: {
      ...state.metadata,
      fetching: false,
      fetchingError: ''
    },
    items: !!data && {
      ...state.items,
      [data.id]: data
    }
  })
}

function setServicePricingRequestFail(
  state: IServicePricingState = initialState,
  action: IServicePricingAction
): IServicePricingState {
  const error = (action as IServicePricingRequestFail).error
  return Object.assign({}, state, {
    metadata: {
      ...state.metadata,
      fetching: false,
      fetchingError: error
    }
  })
}

function setServicePricingProcessing(
  state: IServicePricingState = initialState,
  action: IServicePricingAction
): IServicePricingState {
  return Object.assign({}, state, {
    metadata: {
      ...state.metadata,
      processing: true
    }
  })
}

function setServicePricingProcessingSuccess(
  state: IServicePricingState = initialState,
  action: IServicePricingAction
): IServicePricingState {
  const data = (action as IServicePricingUpdateSuccess).data
  return Object.assign({}, state, {
    metadata: {
      ...state.metadata,
      processing: false
    },
    items: {
      ...state.items,
      [data.id]: data
    }
  })
}

function setServicePricingProcessingFail(
  state: IServicePricingState = initialState,
  action: IServicePricingAction
): IServicePricingState {
  const error = (action as IServicePricingUpdateFail).error
  return Object.assign({}, state, {
    metadata: {
      ...state.metadata,
      processing: false,
      processingError: error
    }
  })
}

const initialState: IServicePricingState = {
  items: {},
  metadata: {
    fetching: false,
    fetchingError: '',
    processing: false,
    processingError: ''
  }
}

export function servicePricing(
  state: IServicePricingState = initialState,
  action: IServicePricingAction
): IServicePricingState {
  switch (action.type) {
    case SERVICE_PRICING_REQUEST:
      return setServicePricingRequesting(state, action)
    case SERVICE_PRICING_REQUEST_SUCCESS:
      return setServicePricingRequestSuccess(state, action)
    case SERVICE_PRICING_REQUEST_FAIL:
      return setServicePricingRequestFail(state, action)
    case SERVICE_PRICING_UPDATE:
      return setServicePricingProcessing(state, action)
    case SERVICE_PRICING_UPDATE_SUCCESS:
      return setServicePricingProcessingSuccess(state, action)
    case SERVICE_PRICING_UPDATE_FAIL:
      return setServicePricingProcessingFail(state, action)
    default:
      return state
  }
}

export function getServicePricing(
  state: IStoreState,
  serviceId: string,
  orgId: string
): IServicePricingModel | undefined {
  return Object.values(state.servicePricing.items).find((it: IServicePricingModel) => {
    return it.serviceId === serviceId && it.orgId === orgId
  })
}



// WEBPACK FOOTER //
// ./src/state/reducers/services/servicePricing.ts